import useTranslation from 'next-translate/useTranslation'
import {
  OurObsessionBody,
  OurObsessionContent,
  OurObsessionIcon,
  OurObsessionImage,
  OurObsessionRoot,
  OurObsessionTitle,
  OurObsessionText,
  HeartLightningContainer,
  OurObsessionHeader,
} from './QualityObsession.styles'
import { WhiteBlobContainer, FeatureRow } from '../../OurStory.styles'
import Image, { StaticImageData } from 'next/image'
import DogEating from '../../../../../public/assets/our-story/quality-obsession/dog-being-fed.jpg'
import LambGrazing from '../../../../../public/assets/our-story/quality-obsession/lamb-grazing.jpg'
import PackingLine from '../../../../../public/assets/our-story/quality-obsession/raw-packaging-line.jpg'
import WhiteBlob from '../../../../../public/assets/our-story/white-blob.svg'
import HeartLightning from '../../../../../public/assets/icons/heart-lightning.svg'
import { Features } from '../Features'

export type SectionInfoTypes = {
  title: string
  highlight: string
  body: string
  image: StaticImageData
  imageAlt: string
  orientation: 'left' | 'right'
  marginTop: boolean
  features: boolean
}

export const QualityObsession = ({ isDesktop }: any) => {
  const { t } = useTranslation()

  const sectionInfo: SectionInfoTypes[] = [
    {
      title: t('our-story:our-obsession.title-1'),
      highlight: t('our-story:our-obsession.body-highlight-1'),
      body: t('our-story:our-obsession.body-1'),
      image: DogEating,
      imageAlt: t('our-story:our-obsession.imageAlt-1'),
      orientation: 'left',
      marginTop: false,
      features: false,
    },
    {
      title: t('our-story:our-obsession.title-2'),
      highlight: t('our-story:our-obsession.body-highlight-2'),
      body: t('our-story:our-obsession.body-2'),
      image: LambGrazing,
      imageAlt: t('our-story:our-obsession.imageAlt-2'),
      orientation: 'right',
      marginTop: true,
      features: true,
    },
    {
      title: t('our-story:our-obsession.title-3'),
      highlight: t('our-story:our-obsession.body-highlight-3'),
      body: t('our-story:our-obsession.body-3'),
      image: PackingLine,
      imageAlt: t('our-story:our-obsession.imageAlt-3'),
      orientation: 'left',
      marginTop: true,
      features: false,
    },
  ]

  return (
    <OurObsessionRoot id="our-story-3">
      <WhiteBlobContainer location="1" rotation="1">
        <HeartLightningContainer>
          <Image className="heart" src={HeartLightning} alt="" />
        </HeartLightningContainer>
        <Image src={WhiteBlob} alt="" />
      </WhiteBlobContainer>
      <WhiteBlobContainer location="2" rotation="1">
        <Image src={WhiteBlob} alt="" />
      </WhiteBlobContainer>
      <OurObsessionHeader>{t('our-story:our-obsession.section-title')}</OurObsessionHeader>
      {sectionInfo.map((info, index) => (
        <OurObsessionContent orientation={info.orientation} marginTop={info.marginTop} key={index}>
          <OurObsessionImage>
            <Image src={info.image} alt={info.imageAlt} />
          </OurObsessionImage>
          <OurObsessionText>
            <OurObsessionTitle>{info.title}</OurObsessionTitle>
            <OurObsessionBody>
              <b>{info.highlight} </b>
              {info.body}
            </OurObsessionBody>
            {info.features && (
              <FeatureRow>
                <Features />
              </FeatureRow>
            )}
          </OurObsessionText>
        </OurObsessionContent>
      ))}
    </OurObsessionRoot>
  )
}
